import { GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';
import React from 'react';
import { useSelector } from 'react-redux';
import ticketImg from '../../Images/tickets.png';
import taskImg from '../../Images/tasks.png';

const CustomCellClick = (props) => {

  const sharedData = useSelector((state) => state.SharedLayoutData)
  const value = props.dataItem[props.field];
  // const HandleTdClick = () => {
  //   props.ParentCallback({
  //     ...props.State,
  //     dataItem: props.dataItem,
  //     fieldName: props.field
  //   });
  // }

  return (
    <>
      {
        (props.field === 'practiceName' && sharedData.CurrentTab === 'clients') ?
          (props.dataItem.accountType && props.dataItem.accountType.toUpperCase() === 'LIVE') ?
            <td
              className={`${props.isSelected ? 'k-state-selected' : ''} Comments30 pl-4 cursor-pointer clickable-cell`}
              colSpan={props.colSpan}
              role="gridcell"
              aria-selected={props.isSelected}
              style={{ color: 'green' }}   //              onClick={(e) => HandleTdClick(e)}
              {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
              title={props.dataItem.practiceName}
            >
              {props.dataItem.practiceName}
            </td>
            :
            props.dataItem.accountType && props.dataItem.accountType.toUpperCase() === 'INACTIVE' ?

              <td
                className={`${props.isSelected ? 'k-state-selected' : ''} Comments30 pl-4 cursor-pointer`}
                colSpan={props.colSpan}
                role="gridcell"
                aria-selected={props.isSelected}
                style={{ color: 'red' }}  //                onClick={(e) => HandleTdClick(e)}
                {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
                title={props.dataItem.practiceName}
              >
                {props.dataItem.practiceName}
              </td>
              :
              <td
                className={`${props.isSelected ? 'k-state-selected' : ''} Comments30 pl-4 cursor-pointer`}
                colSpan={props.colSpan}
                role="gridcell"
                aria-selected={props.isSelected}
                style={{ color: 'orange' }} //                onClick={(e) => HandleTdClick(e)}
                {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
                title={props.dataItem.practiceName}
              >
                {props.dataItem.practiceName}
              </td>
          :
          <td
            className={`${props.isSelected ? 'k-state-selected' : ''} form-text clickField pl-4 cursor-pointer`}
            colSpan={props.colSpan}
            role="gridcell"
            aria-selected={props.isSelected}
            {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
          >
            {
              props.dataItem.TICKET_TYPE !== 'Training And Implementation' ?
                <span>
                  <img src={ticketImg} width={10} alt='' />
                </span>
                :
                <span>
                  <img src={taskImg} width={10} alt='' />
                </span>
            }
            <span
              role='button' //              onClick={(e) => HandleTdClick(e)}
              className="form-text pl-2 ticketValue"
            >
              {value}
            </span>
          </td>
      }
    </>
  );
};

export default CustomCellClick;